const FlatToHierarchy = (items, id = null, link = 'parent', key = '0') =>
                  items
                  .filter(item => item[link] === id)
                  .map((item, index) => ({
                      ...item,
                      key: key + "-" + index.toString(),
                      children: FlatToHierarchy(items, item.id, link, `${key + "-" + index.toString()}`)
                  }));

export default FlatToHierarchy;